/**
 * poppet.ControlModule
 * A control module for creating expandable control interfaces.
 * @version 1.0.1
 */
import View from 'scripts/poppet/view';


const channelNav = Bb.Radio.channel( 'nav' );

const ControlModule = View.extend( {
	
	// ------------------------------------------------
	// Setup
	// ------------------------------------------------
	tagName           : 'div',
	expandedNavState  : false,  // overwrite these nav-states with strings
	compressedNavState: false,  //  to trigger nav-events on expand/implode.
	
	behaviors: {
		ExpandSpoiler: {},
		ViewAnimator : {},
	},
	
	templateContext: function () {
		return {
			isOpen  : this._isOpen(),
		};
	},
	
	
	// ------------------------------------------------
	// Event Handlers
	// ------------------------------------------------
	
	/**
	 * Triggers when the user clicks the toggle-button.
	 * also toggle URL's, decide on default on/off.
	 * @void
	 */
	onClickToggle: function ( event ) {
		
		event.preventDefault();
		
		if ( Mn.getClosestCid( event.target ) !== this.cid ) {
			return;
		}
		
		// Note: happens after the behavior trigger, so the "open" class has just been added or removed.
		let navEvent = ( this.ui.toggle.hasClass( 'open' ) )
					   ? this.expandedNavState
					   : this.compressedNavState;
		
		// As the behavior still triggers the expand/implode, so all we need to do is toggle the url, with an empty
		// options object.
		if ( navEvent ) {
			channelNav.trigger( navEvent, [ this.model.get( 'id' ), ], {} );
		}
		
	},
	
	/**
	 *  Triggers when the view is attached to it's parent.
	 *  !TODO: tidy up this when we know where we're going with it.
	 *  @void
	 */
	onAttach: function() {
		if (this._isHidden() && this.$el.parent().hasClass( 'expandable' ) ) {
			this.$el.parent().addClass( 'hidden' );
		}
		if ( this._isOpen() && this.$el.parent().hasClass( 'expandable' ) ) {
			this.ui.toggle.addClass( 'open' );
		}
		
		this._isModelComplete();
	},
	/**
	 *  Triggers when model i completed.
	 *  @void
	 *  Overwrite this in your control-view if you want something to happen when the model i ready.
	 */
	
	afterModelComplete: function(){
		console.log('Model completed');
	},
	
	
	// ------------------------------------------------
	// Other functions
	// ------------------------------------------------
	
	//If model is not complete, be busy...
	_isModelComplete: function() {
		//Check if model is complete
		if( _.isFunction( this.model.isComplete ) ) {
			if(!this.model.isComplete()) {
				this.busy();
			}

			this.listenTo(this.model, 'change', function( model ){
				if(model.isComplete() && this.isBusy()) {
					//this.stopListening(this.model);
					this.idle();
					this.afterModelComplete();
					
				} else if(!model.isComplete() && !this.isBusy()) {
					this.busy();
				}
			});
		}
	},
	
	/**
	 * Builds a custom className from the variables of the child ViewClass.
	 * @return {string}  A string of space-separated classNames.
	 */
	_getClassName: function ( childClasses ) {
		let classes = 'control-module card';
		
		if ( childClasses ) {
			classes = classes + ' ' + childClasses;
		}
		
		return classes;
	},
	
	/**
	 * Checks if this module should render hidden or not.
	 * @return {bool} True if the module should be hidden, false if not.
	 */
	_isHidden: function () {
		return ( 'hidden' === this.options.state );
	},
	
	/**
	 * Checks if this module should render open or not.
	 * @return {bool} True if the module should be open, false if not.
	 */
	_isOpen: function () {
		return ( 'open' === this.options.state );
	},
	
} );

export default ControlModule;